module.exports = __webpack_public_path__ + "img/screenshot-michaelmorris4judge.2cff72ce.png";